import clsx from 'clsx';

export interface GetInputClassNameProps {
    basicClassName?: string;
    horizontal?: boolean;
    invalidState?: boolean;
    className?: string;
}

export function GetInputClassName({
    basicClassName,
    horizontal,
    invalidState,
    className,
}: GetInputClassNameProps): string {
    return clsx(
        basicClassName,
        className,
        horizontal ? 'flex flex-grow-1' : null,
        invalidState ? 'p-invalid' : null,
    );
}
